<template>
  <div>
    <div class="vx-card">
      <div class="vx-card__body card-body">
        <div class="vx-row">
          <div class="vx-col w-full mb-base">
            <table class="basic-tbl total" id="colored-table">
              <thead class="border-0">
                <tr>
                  <th style="width: 10%" class="border-0">{{ $t("RequesterName") }}</th>
                  <th style="width: 14%" class="border-0">{{ $t("RequesterUsername") }}</th>
                  <th style="width: 10%" class="border-0">{{ $t("Departman") }}</th>
                  <th style="width: 13%" class="border-0">{{ $t("DeliveryDate") }}</th>
                  <th style="width: 13%" class="border-0">{{ $t("CreateOn") }}</th>

                  <th style="width: 40%" class="border-0">{{ $t("Description") }}</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style="width: 10%" class="border-0">
                    {{ model.requesterInfo ? model.requesterInfo.name : "-" }}
                  </td>
                  <td style="width: 14%" class="border-0">
                    {{
                      model.requesterInfo ? model.requesterInfo.userName : "-"
                    }}
                  </td>
                  <td style="width: 10%" class="border-0">
                    {{ model.departmentUnit ? model.departmentUnit.name : "-" }}
                  </td>
                  <td style="width: 20%" class="border-0">
                    {{
                      model.persianDeliveryClock
                        ? model.persianDeliveryClock
                        : "-"
                    }}
                  </td>
                  <td style="width: 13%" class="border-0">
                    {{ model.persianCreateOn ? model.persianCreateOn : "-" }}
                  </td>
                  <td style="width: 33%" class="border-0">
                    {{ model.description ? model.description : "-" }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div class="vx-card mt-5">
      <div class="vx-card__body card-body">
        <div class="vx-row mt-5">
          <div class="vx-col w-full mb-base">
            <vs-table :data="model.purchaseItems" class="custom-tbl" id="colored-table">
              <template slot="thead">
                <th style="width: 10%">{{ $t("ProductName") }}</th>
                  <th style="width: 14%">{{ $t("ModelNumber") }}</th>
                  <th style="width: 10%">{{ $t("Unit") }}</th>
                  <th style="width: 13%">{{ $t("Amounts") }}</th>
              </template>

              <template slot-scope="{ data }">
                <vs-tr v-for="(row, index) in model.purchaseItems" class="custom-table-row">
                  <td style="width: 25%">
                    {{ row.productName ? row.productName : "-" }}
                  </td>
                  <td style="width: 20%">
                    {{ row.modelNumber ? row.modelNumber : "-" }}
                  </td>
                  <td style="width: 15%">
                    {{ row.unitOfMeasures ? row.unitOfMeasures.name : "-" }}
                  </td>
                  <td style="width: 20%">
                    {{ row.count ? row.count : "-" }}
                  </td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
        </div>
      </div>
    </div>
    <div class="flex justify-end w-full ml-4 mt-10">
      <vs-button type="filled" color="danger" @click.prevent="reject">
        <span> {{ $t("Reject") }}</span>
      </vs-button>
      <vs-button
        type="filled"
        color="success"
        class="mr-5"
        @click.prevent="accept"
      >
        <span> {{ $t("Confirm") }}</span>
      </vs-button>
    </div>
  </div>
</template>
<script>
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
import { mapActions } from "vuex";

export default {
  name: "warehouseManagement_CheckinTransactions_Details",
  data() {
    return {
      allUnits: [],
      headerInfo: {},
      model: {},
      editable: true,
      editClicked: false,
      productName: "",
      modelNumber: "",
      amount: 0,
      unit: {},
    };
  },

  mounted() {
    this.load();
  },
  methods: {
    ...mapActions({
      fetchPurchaseRequest: "purchaseRequest/fetchPurchaseRequest",
      acceptRequest: "purchaseRequest/acceptRequest",
      rejectRequest: "purchaseRequest/rejectRequest",
    }),
    load() {
      var id = this.$route.params.id;
      this.fetchPurchaseRequest(id).then((r) => {
        this.model = r;
      });
    },
    reject() {
      this.$swal({
        position: "center-center",
        text: "آیا از رد این درخواست اطمینان دارید؟",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "بلی",
        cancelButtonText: "خیر",
      }).then((result) => {
        if (result.value) {
          this.rejectRequest({ id: this.model.id }).then((r) => {
            this.$swal({
              position: "center-center",
              type: "danger",
              text: "سفارش خرید مورد نظر رد شد",
              showConfirmButton: false,
              timer: 2000,
            }).then(() => {
              this.$router.go(-1);
            });
          });
        }
      });
    },
    accept() {
      this.$swal({
        position: "center-center",
        text: "آیا تایید این درخواست اطمینان دارید؟",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "بلی",
        cancelButtonText: "خیر",
      }).then((result) => {
        if (result.value) {
          this.acceptRequest({ id: this.model.id }).then((r) => {
            this.$swal({
              position: "center-center",
              type: "success",
              text: "سفارش خرید مورد نظر تایید شد",
              showConfirmButton: false,
              timer: 2000,
            }).then(() => {
              this.$router.go(-1);
            });
          });
        }
      });
    },
  },
};
</script>
<style>
.custom-table-row .tr-values td{
  padding: 12px 8px !important;
  
} 
#colored-table thead tr th{
  color: white;
}
</style>